/* eslint-disable no-use-before-define */
const { REACT_APP_PROXY_HOST } = process.env;

const ENDPOINTS_RECHERCHE = [
  (REACT_APP_PROXY_HOST || '') + '/monitoring/graphe/recherche',
  (REACT_APP_PROXY_HOST || '') + '/monitoring/graphe/investigation',
];

const ENDPOINT_INVESTIGATION_CAMERA = (REACT_APP_PROXY_HOST || '') + '/monitoring/camera/investigation';
const ENDPOINT_SNAPSHOT_CAMERA = (REACT_APP_PROXY_HOST || '') + '/monitoring/camera/snapshot';
const ENDPOINT_REPROJECTION_SNAPSHOT = (REACT_APP_PROXY_HOST || '') + '/monitoring/camera/snapshot/reprojeter';
const ENDPOINT_INSTRUMENTATION = (REACT_APP_PROXY_HOST || '') + '/monitoring/graphe/instrumentation';
const ENDPOINT_SYNCCAMLOG_JOURNEE = (REACT_APP_PROXY_HOST || '') + '/monitoring/camera/synccamlog-journee';
const CLE_TRACES_LOCALES = 'syncstats.cockpit.traces.v1';

export const chargerInvestigationCamera = async ({ camera, journee = '', incident = '', debut = '', fin = '', event = '', episode = '' }) => {
  const url = construireUrl(ENDPOINT_INVESTIGATION_CAMERA, {
    camera,
    journee,
    incident,
    debut,
    fin,
    event,
    episode,
  });
  const reponse = await fetch(url, { method: 'GET' });
  const texte = await reponse.text();

  if (!reponse.ok) {
    throw new Error('HTTP ' + reponse.status + ' ' + reponse.statusText);
  }

  return normaliserPayloadInvestigationCamera(texte ? JSON.parse(texte) : null);
};

export const rechercherInvestigation = async ({ requete, profondeur = 4 }) => {
  const erreurs = [];

  for (let index = 0; index < ENDPOINTS_RECHERCHE.length; index += 1) {
    const endpoint = ENDPOINTS_RECHERCHE[index];
    const url = construireUrl(endpoint, {
      q: requete,
      requete,
      profondeur,
    });

    try {
      const reponse = await fetch(url, { method: 'GET' });
      const texte = await reponse.text();

      if (!reponse.ok) {
        throw new Error('HTTP ' + reponse.status + ' ' + reponse.statusText);
      }

      return normaliserPayloadInvestigation(texte ? JSON.parse(texte) : null);
    } catch (erreur) {
      erreurs.push({
        endpoint,
        message: erreur.message,
      });
    }
  }

  const erreur = new Error('Aucun endpoint investigation disponible.');
  erreur.details = erreurs;
  throw erreur;
};

export const chargerSnapshotCamera = async ({ id }) => {
  const url = construireUrl(ENDPOINT_SNAPSHOT_CAMERA, { id });
  const reponse = await fetch(url, { method: 'GET' });
  const texte = await reponse.text();

  if (!reponse.ok) {
    throw new Error('HTTP ' + reponse.status + ' ' + reponse.statusText);
  }

  const payload = texte ? JSON.parse(texte) : null;
  return payload && payload.snapshot ? payload.snapshot : null;
};

export const reprojeterSnapshotCamera = async ({ id }) => {
  const url = construireUrl(ENDPOINT_REPROJECTION_SNAPSHOT, { id });
  const reponse = await fetch(url, { method: 'POST' });
  const texte = await reponse.text();
  const payload = parserJsonApi(texte);

  if (!reponse.ok) {
    throw new Error(messageErreurApi(payload, reponse, texte, url));
  }

  if (!payload) {
    throw new Error('Reprojection appelee, mais la reponse du serveur n est pas du JSON. Verifiez que le backend monitoring a ete redemarre avec la route /monitoring/camera/snapshot/reprojeter.');
  }

  return payload;
};

export const telechargerSyncCamLogJournee = async ({ camera, journee }) => {
  const url = construireUrl(ENDPOINT_SYNCCAMLOG_JOURNEE, { camera, journee });
  const reponse = await fetch(url, { method: 'GET' });
  if (!reponse.ok) {
    const texte = await reponse.text().catch(() => '');
    const payload = texte ? JSON.parse(texte) : {};
    throw new Error(payload.message || 'HTTP ' + reponse.status + ' ' + reponse.statusText);
  }
  return reponse.blob();
};

export const tracerUsageCockpit = (type, details = {}) => {
  const trace = {
    type,
    details,
    timestamp: new Date().toISOString(),
    chemin: typeof window !== 'undefined' ? window.location.pathname : '/cockpit',
  };

  try {
    const traces = JSON.parse(localStorage.getItem(CLE_TRACES_LOCALES) || '[]');
    const prochainesTraces = [trace].concat(traces).slice(0, 100);
    localStorage.setItem(CLE_TRACES_LOCALES, JSON.stringify(prochainesTraces));
  } catch (erreurStockage) {
    // L'investigation ne doit jamais etre bloquee par l'instrumentation.
  }

  try {
    fetch(construireUrl(ENDPOINT_INSTRUMENTATION), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(trace),
    }).catch(() => {});
  } catch (erreurFetch) {
    // Best effort seulement.
  }
};

export const lireTracesLocalesCockpit = () => {
  try {
    return JSON.parse(localStorage.getItem(CLE_TRACES_LOCALES) || '[]');
  } catch (erreur) {
    return [];
  }
};

export const normaliserPayloadInvestigation = (payload) => {
  const source = Array.isArray(payload)
    ? payload
    : payload && Array.isArray(payload.resultats)
      ? payload.resultats
      : payload
        ? [payload]
        : [];

  return {
    versionContrat: payload && payload.versionContrat ? payload.versionContrat : 'inconnu',
    requete: payload && payload.requete ? payload.requete : '',
    profondeur: payload && payload.profondeur ? payload.profondeur : null,
    resultats: source.map((item, index) => normaliserResultat(item, index)).filter(Boolean),
    metriques: payload && payload.metriques ? payload.metriques : {},
    avertissements: payload && payload.avertissements ? payload.avertissements : [],
    heuristiques: payload && payload.heuristiques ? payload.heuristiques : [],
    sourcesSql: payload && payload.sourcesSql ? payload.sourcesSql : [],
    brut: payload,
  };
};

export const normaliserPayloadInvestigationCamera = (payload) => ({
  versionContrat: payload && payload.versionContrat ? payload.versionContrat : 'inconnu',
  camera: payload && payload.camera ? payload.camera : '',
  journee: payload && payload.journee ? payload.journee : '',
  incident: payload && payload.incident ? payload.incident : '',
  contexteIncident: payload && payload.contexteIncident ? payload.contexteIncident : {},
  focus: payload && payload.focus ? payload.focus : {},
  snapshots: payload && payload.snapshots ? payload.snapshots : { syncCamLog: [], bdLogFile: [], autres: [] },
  timelineRuntime: payload && Array.isArray(payload.timelineRuntime) ? payload.timelineRuntime : [],
  etatVideo: payload && payload.etatVideo ? payload.etatVideo : { snapshots: [], indices: [] },
  incidents: payload && Array.isArray(payload.incidents) ? payload.incidents : [],
  journees: payload && Array.isArray(payload.journees) ? payload.journees : [],
  debugSnapshotsSources: payload && payload.debugSnapshotsSources ? payload.debugSnapshotsSources : null,
  metriques: payload && payload.metriques ? payload.metriques : {},
  avertissements: payload && payload.avertissements ? payload.avertissements : [],
  heuristiques: payload && payload.heuristiques ? payload.heuristiques : [],
  brut: payload,
});

const normaliserResultat = (item, index) => {
  if (!item) {
    return null;
  }

  const brut = item.brut || item;
  const racine = item.racine || brut.racine || {};

  return {
    id: racine.id || item.id || 'resultat-' + index,
    racine,
    resumeNarratif: item.resumeNarratif || brut.narration || [],
    dernierSuccesProuve: item.dernierSuccesProuve || brut.dernierSuccesProuve || null,
    anomaliesStagnations: item.anomaliesStagnations || brut.anomalies || [],
    timelineOrdonnee: item.timelineOrdonnee || brut.timeline || [],
    relationsManquantes: item.relationsManquantes || brut.relationsManquantes || [],
    voisinageRelationnel: item.voisinageRelationnel || {
      objets: brut.objets || [],
      relations: brut.relations || [],
    },
    preuves: item.preuves || extrairePreuvesDepuisObjets(brut.objets || []),
    prochainEtatAttendu: item.prochainEtatAttendu || extraireProchainEtat(item, brut),
    resumeOperationnel: item.resumeOperationnel || brut.resumeOperationnel || null,
    sources: item.sources || brut.sources || {},
    brut,
  };
};

const extrairePreuvesDepuisObjets = (objets) => objets.flatMap((objet) => (
  (objet.preuves || []).map((preuve) => ({
    objetId: objet.id,
    typeObjet: objet.type,
    preuve,
  }))
));

const extraireProchainEtat = (item, brut) => {
  const dernierSucces = item.dernierSuccesProuve || brut.dernierSuccesProuve;
  if (dernierSucces && dernierSucces.prochain_etat_attendu) {
    return {
      source: 'dernier_succes_prouve',
      etat: dernierSucces.prochain_etat_attendu,
      preuve_manquante: dernierSucces.preuve_manquante,
    };
  }

  const vieillissement = brut.vieillissement || [];
  const prochain = vieillissement.find((itemVieillissement) => itemVieillissement.expected_next_state);
  return prochain ? {
    source: prochain.objetId,
    etat: prochain.expected_next_state,
    preuve_manquante: prochain.missing_evidence,
  } : null;
};

const construireUrl = (endpoint, params = {}) => {
  const query = Object.keys(params)
    .filter((cle) => params[cle] !== undefined && params[cle] !== null && params[cle] !== '')
    .map((cle) => encodeURIComponent(cle) + '=' + encodeURIComponent(params[cle]))
    .join('&');

  return endpoint + (query ? '?' + query : '');
};

const parserJsonApi = (texte) => {
  if (!texte) return {};
  try {
    return JSON.parse(texte);
  } catch (erreur) {
    return null;
  }
};

const messageErreurApi = (payload, reponse, texte, url) => {
  if (payload) {
    return payload.message
      || (payload.erreurs || []).join(', ')
      || payload.erreur
      || ('HTTP ' + reponse.status + ' ' + reponse.statusText);
  }

  const extrait = String(texte || '').trim().slice(0, 220);
  return 'HTTP ' + reponse.status + ' ' + reponse.statusText
    + ' - reponse non JSON pour ' + url
    + (extrait ? ' - debut: ' + extrait : '');
};



// WEBPACK FOOTER //
// src/components/cockpit/cockpitApi.js